"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var useStatus_1 = require("../useStatus");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var MobileRow = function (_a) {
    var action = _a.action, paymentSystem = _a.paymentSystem, date = _a.date, status = _a.status, amount = _a.amount, idx = _a.idx;
    var t = (0, next_intl_1.useTranslations)('translation');
    var getStatus = (0, useStatus_1.useGetStatus)();
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(idx % 2 === 0 ? styles_module_scss_1.default.odd : '') },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.currency }, amount),
            react_1.default.createElement("div", null),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, action)),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.caption }, t('paymentSystem')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.caption }, t('added')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.caption }, t('status'))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, paymentSystem),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, date),
            react_1.default.createElement("div", null,
                react_1.default.createElement(ui_components_1.StatusText, { textAlign: "flex-start", status: getStatus(status) }, t("".concat(status)))))));
};
exports.default = MobileRow;
